export default __webpack_public_path__ + "static/media/Group-1863@2x.7d68fb15.png";